import { render } from "./InsertCodeView.vue?vue&type=template&id=0ff6a476"
import script from "./InsertCodeView.vue?vue&type=script&lang=js"
export * from "./InsertCodeView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Emertat\\Desktop\\p\\nazerhelp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__